import { render, staticRenderFns } from "./BiomassMapOrder.vue?vue&type=template&id=0c55e36e&scoped=true&lang=html&"
import script from "./BiomassMapOrder.vue?vue&type=script&lang=js&"
export * from "./BiomassMapOrder.vue?vue&type=script&lang=js&"
import style0 from "./BiomassMapOrder.vue?vue&type=style&index=0&id=0c55e36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55e36e",
  null
  
)

export default component.exports